module.exports = __webpack_public_path__ + "contact_phone_icon.c464dcdce5ba9cd80635.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share/contact_phone_icon.svg
// module id = 449
// module chunks = 0